export default {
  props: ['type', 'active', 'pointClass', 'pointValue'],
  computed: {
    classes() {
      let classes = [];
      if (undefined !== this.type) {
        classes.push(this.type);
        if (this.active) {
          classes.push(`${this.type}-active`);
          classes.push(`active`);
        }
      }
      return classes;
    },
  },
  methods: {
    passMethod(methodName) {
      this.$emit(methodName || 'click');
    },
  },
};
